const prevUrl = "finance/receivableVerification";
export const id = {
    id: "FINANCIAL_MANAGEMENT_RECEIVABLE_WRITE_OFF",
    method: "POST",
    name: "应收核销",
    type: "menu",
    apiName: "getReceivableWriteOfftiSummary",
    url: `${prevUrl}/list`
};

export const children = {
    EXPORT_ALL: {
        id: "FINANCIAL_MANAGEMENT_RECEIVABLE_WRITE_OFF_EXPORT_ALL",
        apiName: "exportReceivableWriteOfftSummary",
        method: "POSTFILE",
        name: "总表导出",
        type: "view",
        url: `${prevUrl}/exportSummary`
    },
    EXPORT_SUB: {
        id: "FINANCIAL_MANAGEMENT_RECEIVABLE_WRITE_OFF_EXPORT_SUB",
        apiName: "exportReceivableWriteOfftDetail",
        method: "POSTFILE",
        name: "分表导出",
        type: "view",
        url: `${prevUrl}/exportDetail`
    },
    SEARCH: {
        id: "FINANCIAL_MANAGEMENT_RECEIVABLE_WRITE_OFF_SEARCH",
        name: "查询",
        type: "view"
    }
};
